import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "../lib/api";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { Machine } from "../components/site/Machine";
import { LaserJourney } from "../components/site/LaserJourney";
import { Pricing } from "../components/site/Pricing";
import { Testimonials } from "../components/site/Testimonials";
import { Booking } from "../components/site/Booking";
import { Footer } from "../components/site/Footer";

export default function Home() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const anchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", anchor);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", anchor);
    };
  }, []);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => setConfig({ settings: {}, services: [] }));
  }, []);

  return (
    <div className="App bg-cream" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Machine />
      <LaserJourney />
      {config && <Pricing services={config.services} />}
      {config && <Testimonials services={config.services} />}
      {config && <Booking services={config.services} />}
      <Footer settings={config?.settings} />
    </div>
  );
}
